let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8WFBq")).then(() => parcelRequire('bzESo'));